export const profile = {
  name: 'Angelo Mayuga',
  fullName: 'Angelo P. Mayuga',
  title: 'Full Stack Developer',
  moto: 'Embrace the journey, overcome the challenges, and unleash your true potential, for greatness lies within those who dare to dream, persevere, and never give up.',
  bio: 'Full Stack Developer with 3+ years of professional experience at Innsite IT Solution, building scalable web applications and delivering client-focused software solutions.',
  verse: 'Proverbs 16:3 – Commit your work to the Lord, and your plans will be established.',
  roles: ['Full Stack Developer', 'Vue & Laravel Engineer', 'Mobile Developer', 'AI-Augmented Builder'],
  informations: {
    name: 'Angelo P. Mayuga',
    birthday: 'May 06, 2001',
    Website: 'https://gelo-website.web.app/',
    degree: "Bachelor's Degree in Information Technology",
    freelance: true,
    email: 'angelomayuga70@gmail.com',
    homeaddress: 'Bagong Buhay, Victoria, Oriental Mindoro',
    currentaddress: 'Bagong Buhay, Victoria, Oriental Mindoro',
    contact: '09278204051',
    mother_name: 'Lucia P. Mayuga',
    father_name: 'Daniel M. Mayuga',
    father_occupation: 'Farmer',
    father_birthdate: 'January 03, 1962',
    mother_birthdate: 'December 19, 1964',
    mother_occupation: 'Housewife',
    civil_status: 'Single',
    birthdayplace: 'Calapan',
    objectives:
      'Full Stack Developer with 3+ years of professional experience at Innsite IT Solution, specializing in Vue.js, Laravel, PHP, JavaScript, and Firebase. Experienced in AI-assisted development using Cursor, coding agents, and LLMs to accelerate delivery while maintaining production-quality code. Seeking to contribute technical expertise to innovative teams building impactful digital products.',
    summary:
      'Results-driven Full Stack Developer with 3 years at Innsite IT Solution, where I design, build, and maintain end-to-end web solutions for diverse client requirements. Strong foundation in computer science from Mindoro State University, complemented by hands-on experience in agriculture tech, utilities, IoT, and enterprise systems. Proficient in AI-augmented workflows—using Cursor, coding agents, and prompt engineering to ship features faster, debug efficiently, and iterate on solutions without sacrificing code quality.',
  },
  social: {
    facebook: 'https://www.facebook.com/angelomayuga70',
    linkedin: 'https://www.linkedin.com/in/mayuga-angelo-p-633251269/',
    instagram: '#',
  },
}

export const skills = [
  {
    id: 'basic',
    title: 'Language skills',
    description: 'Core programming fundamentals',
    items: [
      { name: 'HTML', level: 100 },
      { name: 'CSS', level: 90 },
      { name: 'JavaScript', level: 90 },
      { name: 'PHP', level: 80 },
      { name: 'Python', level: 60 },
      { name: 'C#', level: 50 },
    ],
  },
  {
    id: 'frameworks',
    title: 'Framework skills',
    description: 'Tools for building modern applications',
    items: [
      { name: 'Laravel', level: 75 },
      { name: 'Vue.js', level: 80 },
      { name: 'Tailwind CSS', level: 60 },
      { name: 'Bootstrap', level: 60 },
    ],
  },
  {
    id: 'ai',
    title: 'AI skills',
    description: 'Cursor, agents, and LLMs for modern development',
    items: [
      { name: 'Cursor AI IDE', level: 92 },
      { name: 'AI Coding Agents', level: 88 },
      { name: 'Prompt Engineering', level: 85 },
      { name: 'AI-Assisted Code Generation', level: 90 },
      { name: 'LLM-Assisted Debugging', level: 85 },
    ],
  },
  {
    id: 'devops',
    title: 'DevOps Skills',
    description: 'Server administration, deployment, and production operations',
    items: [
      { name: 'Linux Server Administration', level: 85 },
      { name: 'Nginx & Apache Configuration', level: 82 },
      { name: 'Application Deployment (Laravel, Vue.js)', level: 88 },
      { name: 'Git & Git-based Deployment', level: 90 },
      { name: 'CI/CD', level: 78 },
      { name: 'Docker', level: 70 },
      { name: 'MySQL Administration', level: 85 },
      { name: 'SSL/TLS Management', level: 80 },
      { name: 'DNS & Domain Management', level: 78 },
      { name: 'Process Management (Supervisor/systemd)', level: 82 },
      { name: 'Redis', level: 75 },
      { name: 'AWS / DigitalOcean / VPS Management', level: 72 },
      { name: 'Monitoring & Troubleshooting', level: 85 },
      { name: 'Backup & Recovery', level: 80 },
    ],
  },
]

export const education = [
  {
    level: 'Primary',
    period: '2007 - 2013',
    school: 'Bagong Buhay Elementary School',
    location: 'Bagong Buhay, Victoria, Oriental Mindoro',
  },
  {
    level: 'Secondary',
    period: '2013 - 2017',
    school: 'Aurelio Arago Memorial National High School - Alcate Annex',
    location: 'Alcate, Victoria, Oriental Mindoro',
  },
  {
    level: 'Senior High School',
    period: '2017 - 2019',
    school: 'ACMCL College',
    location: 'Poblacion 1, Victoria, Oriental Mindoro',
  },
  {
    level: 'Bachelor\'s Degree — Information Technology',
    period: '2019 – 2023',
    school: 'Mindoro State University (MinSU) — Main Campus',
    location: 'Alcate, Victoria, Oriental Mindoro',
  },
]

export const resumeEducation = {
  degree: "Bachelor's Degree in Information Technology",
  school: 'Mindoro State University (MinSU) — Main Campus',
  period: '2019 – 2023',
  location: 'Victoria, Oriental Mindoro',
}

export const personalSkills = [
  'Strong problem-solving and analytical thinking',
  'Effective collaboration in team environments',
  'Clear technical communication',
  'Adaptability and continuous learning',
  'AI-augmented development with Cursor, coding agents, and LLMs',
  'Prompt engineering for scaffolding features, debugging, and refactoring',
  'Delivering faster iterations without compromising code quality',
]

export const experience = [
  {
    role: 'Full Stack Developer',
    company: 'Innsite IT Solution',
    period: '2023 – Present',
    duration: '3 years',
    location: 'Philippines',
    highlights: [
      'Develop and maintain full-stack web applications for client projects using Vue.js, Laravel, PHP, JavaScript, and MySQL.',
      'Design and implement RESTful APIs, database schemas, and admin dashboards that support real-world business workflows.',
      'Collaborate with project managers, designers, and stakeholders to translate requirements into scalable, maintainable software.',
      'Optimize application performance, fix production issues, and support deployments across staging and live environments.',
      'Integrate third-party services, authentication systems, and Firebase features for modern web and mobile-backed solutions.',
      'Use AI development tools (Cursor, coding agents, ChatGPT, and Copilot) to accelerate prototyping, feature delivery, and refactoring.',
      'Participate in code reviews, documentation, and iterative delivery to ensure high-quality releases on schedule.',
    ],
  },
  {
    role: 'Freelance Full Stack Developer',
    company: 'Self-Employed',
    period: '2022 – 2023',
    duration: '',
    location: 'Victoria, Oriental Mindoro',
    highlights: [
      'Delivered custom web applications and portfolio projects for local clients and academic partners.',
      'Built responsive interfaces with Vue.js, Tailwind CSS, Bootstrap, and Firebase.',
    ],
  },
]

export const projectExperience = [
  {
    name: 'E-agaricus',
    type: 'Mobile / IoT',
    description: 'IoT-based mushroom environment monitoring system with sensor integration and real-time alerts.',
  },
  {
    name: 'E-nimal & E-swine',
    type: 'Web Application',
    description: 'Livestock monitoring and swine management platforms with admin dashboards and analytics.',
  },
  {
    name: 'Qbeetech',
    type: 'Web Application',
    description: 'Bee colony monitoring system with environmental tracking and administrative controls.',
  },
  {
    name: 'eAquabill',
    type: 'Mobile Application',
    description: 'Android water billing application for utility management and customer records.',
  },
  {
    name: 'E-H2O Support',
    type: 'Web Application',
    description: 'Dam water level monitoring platform with status visualization and support workflows.',
  },
  {
    name: 'POS System',
    type: 'Desktop / System',
    description: 'Point-of-sale application for inventory, sales tracking, and transaction management.',
  },
]

export const hobbies = ['Music', 'Coding', 'Online Games']

export const technicalSkills = {
  frontend: [
    'HTML',
    'CSS',
    'Tailwind (CSS Framework)',
    'Bootstrap (CSS Framework)',
    'JavaScript (Client Side Scripting Language)',
    'Vue.js (Frontend JS Framework)',
    'Node.js (Library)',
    'Inertia.js (Library)',
    'Vite.js (Tool)',
    'Firebase',
  ],
  backend: [
    'PHP (Server Side Scripting Language)',
    'Laravel (Backend PHP Framework)',
    'Python (Programming Language)',
    'C# (Programming Language)',
    'MySQL',
    'NoSQL',
    'Git',
    'Arduino (Embedded Systems Development)',
  ],
  ai: [
    'Cursor (AI-Powered IDE)',
    'AI Coding Agents (Cursor Agent)',
    'ChatGPT / Claude / Gemini',
    'GitHub Copilot',
    'Prompt Engineering',
    'AI-Assisted Code Generation',
    'LLM-Assisted Debugging & Refactoring',
  ],
  devops: [
    'Linux Server Administration',
    'Nginx & Apache Configuration',
    'Application Deployment (Laravel, Vue.js)',
    'Git & Git-based Deployment',
    'CI/CD',
    'Docker',
    'MySQL Administration',
    'SSL/TLS Management',
    'DNS & Domain Management',
    'Process Management (Supervisor/systemd)',
    'Redis',
    'AWS / DigitalOcean / VPS Management',
    'Monitoring & Troubleshooting',
    'Backup & Recovery',
  ],
}

export const pdfSkills = {
  frontend: ['Vue.js', 'JavaScript', 'HTML5', 'CSS3', 'Tailwind CSS', 'Bootstrap', 'Vite', 'Inertia.js'],
  backend: ['PHP', 'Laravel', 'Node.js', 'REST APIs', 'Python', 'C#'],
  database: ['MySQL', 'Firebase Realtime DB', 'NoSQL'],
  ai: [
    'Cursor AI IDE',
    'AI Coding Agents',
    'Prompt Engineering',
    'ChatGPT / Claude',
    'GitHub Copilot',
    'AI-Assisted Development',
  ],
  tools: ['Git', 'Firebase', 'Capacitor.js', 'Arduino', 'Agile / Scrum'],
  devops: [
    'Linux Server Administration',
    'Nginx & Apache',
    'Laravel / Vue.js Deployment',
    'Git-based Deployment',
    'CI/CD',
    'Docker',
    'MySQL Administration',
    'SSL/TLS',
    'DNS & Domains',
    'Supervisor / systemd',
    'Redis',
    'AWS / DigitalOcean / VPS',
    'Monitoring & Troubleshooting',
    'Backup & Recovery',
  ],
}

export const portfolioItems = [
  {
    id: 1,
    file_type: 'apk',
    repository: '',
    file_name: 'E-agaricus',
    file_url: '',
    host_url: '',
    category: 'mobile',
    publish: false,
    description: 'An IOT Base Mushroom Environment Monitoring System',
  },
  {
    id: 2,
    file_type: 'zip',
    repository: '',
    file_name: 'E-portfolio',
    file_url: '',
    host_url: '',
    category: 'web',
    publish: false,
    description: 'My personal website',
  },
  {
    id: 3,
    file_type: 'rar',
    repository: '',
    file_name: 'E-nimal',
    file_url: '',
    host_url: '',
    category: 'web',
    publish: false,
    description: 'A Livestocks Monitoring System - Admin Side',
  },
  {
    id: 4,
    file_type: 'zip',
    repository: '',
    file_name: 'Qbeetech',
    file_url: '',
    host_url: '',
    category: 'web',
    publish: false,
    description: 'Bee Monitoring System - Admin Side',
  },
  {
    id: 5,
    file_type: 'rar',
    repository: '',
    file_name: 'E-swine',
    file_url: '',
    host_url: '',
    category: 'web',
    publish: false,
    description: 'Swine Management Web Application',
  },
  {
    id: 6,
    file_type: 'apk',
    repository: '',
    file_name: 'eAquabill',
    file_url: '',
    host_url: '',
    category: 'mobile',
    publish: false,
    description: 'Water Billing Android Application',
  },
  {
    id: 7,
    file_type: 'zip',
    repository: '',
    file_name: 'POS',
    file_url: '',
    host_url: '',
    category: 'system',
    publish: false,
    description: 'Point of Sale System',
  },
  {
    id: 8,
    file_type: 'zip',
    repository: '',
    file_name: 'E-H2O Support',
    file_url: '',
    host_url: '',
    category: 'web',
    publish: false,
    description: 'Dam Water Level Monitoring',
  },
]

export const liveProducts = [
  {
    id: 'ourmoment',
    name: 'OurMoment',
    tagline: 'Made for Filipino weddings',
    description:
      'All-in-one wedding platform for Filipino couples — beautiful websites, RSVPs, guest tools, and a supplier marketplace.',
    role: 'Founder / Full-stack',
    liveUrl: 'https://our-moment-ph.com',
    image: '/img/products/ourmoment-logo.svg',
    imageDark: '/img/products/ourmoment-logo-dark.svg',
    logoLayout: 'wordmark',
    tags: ['Vue 3', 'Firebase', 'Tailwind CSS', 'Gemini AI', 'PayMongo'],
  },
  {
    id: 'localstalls',
    name: 'LocalStalls',
    tagline: 'Market and festival management software',
    description:
      'SaaS for market and event organizers — vendor applications, stall bookings, invoicing, payments, site maps, and a vendor CRM. I worked on this product at Innsite IT Solution.',
    role: 'Full-stack developer · Innsite IT Solution',
    liveUrl: 'https://localstalls.com',
    image: '/img/products/localstalls-logo.svg',
    logoLayout: 'wordmark',
    tags: ['Laravel', 'Vue.js', 'PHP', 'Stripe', 'Xero'],
  },
  {
    id: 'siteconx',
    name: 'SiteconX',
    tagline: 'Job management for excavation and civil construction',
    description:
      'SaaS for excavation companies — job scheduling, digital work dockets, plant and asset tracking, invoicing, and compliance. I worked on this product at Innsite IT Solution.',
    role: 'Full-stack developer · Innsite IT Solution',
    liveUrl: 'https://siteconx.com.au',
    image: '/img/products/siteconx-logo.png',
    logoLayout: 'banner',
    tags: ['Laravel', 'Vue.js', 'PHP', 'Stripe', 'Xero'],
  },
]

export const navItems = [
  { name: 'Home', section: 'home', icon: 'Home' },
  { name: 'About', section: 'about', icon: 'User' },
  { name: 'Work', section: 'work', icon: 'Briefcase' },
  { name: 'Resume', section: 'resume', icon: 'FileText' },
  { name: 'Contact', section: 'contact', icon: 'Mail' },
]

export const adminNavItems = [
  { name: 'Dashboard', path: '/admin', icon: 'LayoutGrid' },
  { name: 'Profile & Home', path: '/admin/profile', icon: 'User' },
  { name: 'Resume & Skills', path: '/admin/resume', icon: 'FileText' },
  { name: 'Portfolio', path: '/admin/portfolio', icon: 'Briefcase' },
  { name: 'Messages', path: '/admin/messages', icon: 'Mail' },
  { name: 'Analytics', path: '/admin/analytics', icon: 'BarChart3' },
]
